import actions from '../../actionTypes';

export default action => {
  return {
    type: actions.DELETE_ACTION,
    action
  };
};



// WEBPACK FOOTER //
// ./src/reducers/trigger-actions/actions/deleteAction.js